import { AxiosError } from 'axios'
import { ErrorCodes } from './errorCodes'

export interface LiveReportServiceErrorResponse {
  status: ErrorCodes
  error: string
  info?: string[]
}

export type FetchError = AxiosError<LiveReportServiceErrorResponse>

export const isLiveReportServiceErrorResponse = (
  obj: unknown
): obj is LiveReportServiceErrorResponse =>
  typeof obj === 'object' && obj !== null && 'status' in obj && 'error' in obj
